export const Create = {
  Category: "category" as const,
  Recipient: "recipient" as const,
  Persons: "persons" as const,
  Subject: "subject" as const,
  Message: "message" as const,
  Attachments: "attachments" as const,
}

export const Filter = {
  UserId: "userId" as const,
  UserName: "userName" as const,
  SearchString: "searchString" as const,
  Created: "created" as const,
  Updated: "updated" as const,
  States: "states" as const,
  Severities: "severities" as const,
}

